import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _725d1ecf = () => interopDefault(import('../../../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _3c194924 = () => interopDefault(import('../../../pages/acceder.vue' /* webpackChunkName: "pages/acceder" */))
const _4a4e61cc = () => interopDefault(import('../../../pages/confirmar-pedido.vue' /* webpackChunkName: "pages/confirmar-pedido" */))
const _89939bce = () => interopDefault(import('../../../pages/consumo-minimo.vue' /* webpackChunkName: "pages/consumo-minimo" */))
const _8bbb8c7c = () => interopDefault(import('../../../pages/documentacion.vue' /* webpackChunkName: "pages/documentacion" */))
const _60983624 = () => interopDefault(import('../../../pages/editar-pedido.vue' /* webpackChunkName: "pages/editar-pedido" */))
const _5be44218 = () => interopDefault(import('../../../pages/mi-perfil.vue' /* webpackChunkName: "pages/mi-perfil" */))
const _4990f71e = () => interopDefault(import('../../../pages/mi-saldo.vue' /* webpackChunkName: "pages/mi-saldo" */))
const _e56ea9c2 = () => interopDefault(import('../../../pages/mis-movimientos.vue' /* webpackChunkName: "pages/mis-movimientos" */))
const _57666aef = () => interopDefault(import('../../../pages/mis-pedidos.vue' /* webpackChunkName: "pages/mis-pedidos" */))
const _5486e6ba = () => interopDefault(import('../../../pages/nueva-clave.vue' /* webpackChunkName: "pages/nueva-clave" */))
const _0f7d6120 = () => interopDefault(import('../../../pages/recuperar.vue' /* webpackChunkName: "pages/recuperar" */))
const _48ff19ac = () => interopDefault(import('../../../pages/registro.vue' /* webpackChunkName: "pages/registro" */))
const _32ecd3a0 = () => interopDefault(import('../../../pages/administracion/configuracion.vue' /* webpackChunkName: "pages/administracion/configuracion" */))
const _514660b7 = () => interopDefault(import('../../../pages/administracion/consumo-minimo.vue' /* webpackChunkName: "pages/administracion/consumo-minimo" */))
const _4efcd080 = () => interopDefault(import('../../../pages/administracion/cooperativa.vue' /* webpackChunkName: "pages/administracion/cooperativa" */))
const _163822ba = () => interopDefault(import('../../../pages/administracion/crear-direccion.vue' /* webpackChunkName: "pages/administracion/crear-direccion" */))
const _59c29227 = () => interopDefault(import('../../../pages/administracion/crear-documento.vue' /* webpackChunkName: "pages/administracion/crear-documento" */))
const _5f852595 = () => interopDefault(import('../../../pages/administracion/crear-grupo-consumo.vue' /* webpackChunkName: "pages/administracion/crear-grupo-consumo" */))
const _05ff7e62 = () => interopDefault(import('../../../pages/administracion/crear-pedido.vue' /* webpackChunkName: "pages/administracion/crear-pedido" */))
const _e0bbf486 = () => interopDefault(import('../../../pages/administracion/crear-producto.vue' /* webpackChunkName: "pages/administracion/crear-producto" */))
const _2ce2e7f4 = () => interopDefault(import('../../../pages/administracion/crear-punto-de-recogida.vue' /* webpackChunkName: "pages/administracion/crear-punto-de-recogida" */))
const _87c8b07c = () => interopDefault(import('../../../pages/administracion/crear-transaccion.vue' /* webpackChunkName: "pages/administracion/crear-transaccion" */))
const _75bb6061 = () => interopDefault(import('../../../pages/administracion/crear-usuario.vue' /* webpackChunkName: "pages/administracion/crear-usuario" */))
const _5924c9a7 = () => interopDefault(import('../../../pages/administracion/editar-grupo-consumo.vue' /* webpackChunkName: "pages/administracion/editar-grupo-consumo" */))
const _79b46a90 = () => interopDefault(import('../../../pages/administracion/editar-pedido.vue' /* webpackChunkName: "pages/administracion/editar-pedido" */))
const _2c66c32a = () => interopDefault(import('../../../pages/administracion/editar-producto.vue' /* webpackChunkName: "pages/administracion/editar-producto" */))
const _470e3306 = () => interopDefault(import('../../../pages/administracion/editar-punto-de-recogida.vue' /* webpackChunkName: "pages/administracion/editar-punto-de-recogida" */))
const _7f192854 = () => interopDefault(import('../../../pages/administracion/editar-transaccion.vue' /* webpackChunkName: "pages/administracion/editar-transaccion" */))
const _78a3f9f3 = () => interopDefault(import('../../../pages/administracion/editar-usuario.vue' /* webpackChunkName: "pages/administracion/editar-usuario" */))
const _7b6089ba = () => interopDefault(import('../../../pages/administracion/grupos-consumo.vue' /* webpackChunkName: "pages/administracion/grupos-consumo" */))
const _4e943037 = () => interopDefault(import('../../../pages/administracion/movimientos.vue' /* webpackChunkName: "pages/administracion/movimientos" */))
const _62b03c07 = () => interopDefault(import('../../../pages/administracion/pedidos.vue' /* webpackChunkName: "pages/administracion/pedidos" */))
const _197f768c = () => interopDefault(import('../../../pages/administracion/productos.vue' /* webpackChunkName: "pages/administracion/productos" */))
const _0b458fd5 = () => interopDefault(import('../../../pages/administracion/puntos-recogida.vue' /* webpackChunkName: "pages/administracion/puntos-recogida" */))
const _80c608fe = () => interopDefault(import('../../../pages/administracion/saldos.vue' /* webpackChunkName: "pages/administracion/saldos" */))
const _42d1a09c = () => interopDefault(import('../../../pages/administracion/usuarios.vue' /* webpackChunkName: "pages/administracion/usuarios" */))
const _73465da9 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _725d1ecf,
    name: "404"
  }, {
    path: "/acceder",
    component: _3c194924,
    name: "acceder"
  }, {
    path: "/confirmar-pedido",
    component: _4a4e61cc,
    name: "confirmar-pedido"
  }, {
    path: "/consumo-minimo",
    component: _89939bce,
    name: "consumo-minimo"
  }, {
    path: "/documentacion",
    component: _8bbb8c7c,
    name: "documentacion"
  }, {
    path: "/editar-pedido",
    component: _60983624,
    name: "editar-pedido"
  }, {
    path: "/mi-perfil",
    component: _5be44218,
    name: "mi-perfil"
  }, {
    path: "/mi-saldo",
    component: _4990f71e,
    name: "mi-saldo"
  }, {
    path: "/mis-movimientos",
    component: _e56ea9c2,
    name: "mis-movimientos"
  }, {
    path: "/mis-pedidos",
    component: _57666aef,
    name: "mis-pedidos"
  }, {
    path: "/nueva-clave",
    component: _5486e6ba,
    name: "nueva-clave"
  }, {
    path: "/recuperar",
    component: _0f7d6120,
    name: "recuperar"
  }, {
    path: "/registro",
    component: _48ff19ac,
    name: "registro"
  }, {
    path: "/administracion/configuracion",
    component: _32ecd3a0,
    name: "administracion-configuracion"
  }, {
    path: "/administracion/consumo-minimo",
    component: _514660b7,
    name: "administracion-consumo-minimo"
  }, {
    path: "/administracion/cooperativa",
    component: _4efcd080,
    name: "administracion-cooperativa"
  }, {
    path: "/administracion/crear-direccion",
    component: _163822ba,
    name: "administracion-crear-direccion"
  }, {
    path: "/administracion/crear-documento",
    component: _59c29227,
    name: "administracion-crear-documento"
  }, {
    path: "/administracion/crear-grupo-consumo",
    component: _5f852595,
    name: "administracion-crear-grupo-consumo"
  }, {
    path: "/administracion/crear-pedido",
    component: _05ff7e62,
    name: "administracion-crear-pedido"
  }, {
    path: "/administracion/crear-producto",
    component: _e0bbf486,
    name: "administracion-crear-producto"
  }, {
    path: "/administracion/crear-punto-de-recogida",
    component: _2ce2e7f4,
    name: "administracion-crear-punto-de-recogida"
  }, {
    path: "/administracion/crear-transaccion",
    component: _87c8b07c,
    name: "administracion-crear-transaccion"
  }, {
    path: "/administracion/crear-usuario",
    component: _75bb6061,
    name: "administracion-crear-usuario"
  }, {
    path: "/administracion/editar-grupo-consumo",
    component: _5924c9a7,
    name: "administracion-editar-grupo-consumo"
  }, {
    path: "/administracion/editar-pedido",
    component: _79b46a90,
    name: "administracion-editar-pedido"
  }, {
    path: "/administracion/editar-producto",
    component: _2c66c32a,
    name: "administracion-editar-producto"
  }, {
    path: "/administracion/editar-punto-de-recogida",
    component: _470e3306,
    name: "administracion-editar-punto-de-recogida"
  }, {
    path: "/administracion/editar-transaccion",
    component: _7f192854,
    name: "administracion-editar-transaccion"
  }, {
    path: "/administracion/editar-usuario",
    component: _78a3f9f3,
    name: "administracion-editar-usuario"
  }, {
    path: "/administracion/grupos-consumo",
    component: _7b6089ba,
    name: "administracion-grupos-consumo"
  }, {
    path: "/administracion/movimientos",
    component: _4e943037,
    name: "administracion-movimientos"
  }, {
    path: "/administracion/pedidos",
    component: _62b03c07,
    name: "administracion-pedidos"
  }, {
    path: "/administracion/productos",
    component: _197f768c,
    name: "administracion-productos"
  }, {
    path: "/administracion/puntos-recogida",
    component: _0b458fd5,
    name: "administracion-puntos-recogida"
  }, {
    path: "/administracion/saldos",
    component: _80c608fe,
    name: "administracion-saldos"
  }, {
    path: "/administracion/usuarios",
    component: _42d1a09c,
    name: "administracion-usuarios"
  }, {
    path: "/",
    component: _73465da9,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
